var $h6i5w$react = require("react");
var $h6i5w$reactjsxruntime = require("react/jsx-runtime");
var $h6i5w$styledcomponents = require("styled-components");
var $h6i5w$muimaterialTab = require("@mui/material/Tab");
var $h6i5w$muimaterialTabs = require("@mui/material/Tabs");

"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Tabs", {
    enumerable: true,
    get: function get() {
        return $fa133ff3e22f1eb7$exports.Tabs;
    }
});
var $fa133ff3e22f1eb7$exports = {};
"use strict";
function $fa133ff3e22f1eb7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fa133ff3e22f1eb7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fa133ff3e22f1eb7$var$_typeof(o);
}
Object.defineProperty($fa133ff3e22f1eb7$exports, "__esModule", {
    value: true
});
$fa133ff3e22f1eb7$exports.onChange = $fa133ff3e22f1eb7$exports.Tabs = void 0;

var $fa133ff3e22f1eb7$var$_react = $fa133ff3e22f1eb7$var$_interopRequireWildcard($h6i5w$react);
var $0c680dbfab605dda$exports = {};
"use strict";
function $0c680dbfab605dda$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0c680dbfab605dda$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0c680dbfab605dda$var$_typeof(o);
}
Object.defineProperty($0c680dbfab605dda$exports, "__esModule", {
    value: true
});
$0c680dbfab605dda$exports.StyledTabs = $0c680dbfab605dda$exports.StyledTab = void 0;

var $0c680dbfab605dda$var$_react = $0c680dbfab605dda$var$_interopRequireDefault($h6i5w$react);

var $0c680dbfab605dda$var$_styledComponents = $0c680dbfab605dda$var$_interopRequireWildcard($h6i5w$styledcomponents);

var $0c680dbfab605dda$var$_Tab = $0c680dbfab605dda$var$_interopRequireDefault($h6i5w$muimaterialTab);

var $0c680dbfab605dda$var$_Tabs = $0c680dbfab605dda$var$_interopRequireDefault($h6i5w$muimaterialTabs);
var $e3408eb85cf737bc$exports = {};
"use strict";
Object.defineProperty($e3408eb85cf737bc$exports, "__esModule", {
    value: true
});
$e3408eb85cf737bc$exports.tabRootStyles = $e3408eb85cf737bc$exports.tabLabelContainerStyles = $e3408eb85cf737bc$exports.sizeStyles = $e3408eb85cf737bc$exports.rippleStyle = $e3408eb85cf737bc$exports.labelStyles = $e3408eb85cf737bc$exports.defaultTabIndicatorStyle = $e3408eb85cf737bc$exports.defaultRootStyle = $e3408eb85cf737bc$exports.defaultLabelStyle = void 0;
var $bebaee556f9a4756$exports = {};
"use strict";
Object.defineProperty($bebaee556f9a4756$exports, "__esModule", {
    value: true
});
$bebaee556f9a4756$exports.FONTS = void 0;
var $bebaee556f9a4756$var$FONTS = $bebaee556f9a4756$exports.FONTS = {
    displayXXL: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "62px",
        lineHeight: "150%"
    },
    displayXL: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "46px",
        lineHeight: "150%"
    },
    displayL: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "34px",
        lineHeight: "150%"
    },
    displayM: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "24px",
        lineHeight: "150%"
    },
    displayS: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "18px",
        lineHeight: "180%"
    },
    displayXS: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "14px",
        lineHeight: "180%"
    },
    displayXXS: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "12px",
        lineHeight: "180%"
    },
    bodyL: {
        fontFamily: '"Inter", sans-serif',
        fontSize: "18px",
        lineHeight: "180%"
    },
    bodyM: {
        fontFamily: '"Inter", sans-serif',
        fontSize: "14px",
        lineHeight: "180%"
    },
    bodyS: {
        fontFamily: '"Inter", sans-serif',
        fontSize: "12px",
        lineHeight: "180%"
    },
    bodyXS: {
        fontFamily: '"Inter", sans-serif',
        fontSize: "10px",
        lineHeight: "180%"
    }
};


var $bb6a8a3022cc23ea$exports = {};
"use strict";
Object.defineProperty($bb6a8a3022cc23ea$exports, "__esModule", {
    value: true
});
$bb6a8a3022cc23ea$exports.viewports = $bb6a8a3022cc23ea$exports.typoSelector = $bb6a8a3022cc23ea$exports.typo = $bb6a8a3022cc23ea$exports.query = $bb6a8a3022cc23ea$exports.layer = $bb6a8a3022cc23ea$exports.gradient = $bb6a8a3022cc23ea$exports.fontWeight = $bb6a8a3022cc23ea$exports.colorSelector = $bb6a8a3022cc23ea$exports.color = $bb6a8a3022cc23ea$exports.breakpoint = $bb6a8a3022cc23ea$exports.boxShadowFocus = $bb6a8a3022cc23ea$exports.boxShadow = $bb6a8a3022cc23ea$exports.border = $bb6a8a3022cc23ea$exports.Theme = void 0;


var $bb6a8a3022cc23ea$var$_templateObject, $bb6a8a3022cc23ea$var$_templateObject2, $bb6a8a3022cc23ea$var$_templateObject3, $bb6a8a3022cc23ea$var$_templateObject4, $bb6a8a3022cc23ea$var$_templateObject5, $bb6a8a3022cc23ea$var$_templateObject6, $bb6a8a3022cc23ea$var$_templateObject7, $bb6a8a3022cc23ea$var$_templateObject8, $bb6a8a3022cc23ea$var$_templateObject9, $bb6a8a3022cc23ea$var$_templateObject10, $bb6a8a3022cc23ea$var$_templateObject11, $bb6a8a3022cc23ea$var$_templateObject12, $bb6a8a3022cc23ea$var$_templateObject13, $bb6a8a3022cc23ea$var$_templateObject14, $bb6a8a3022cc23ea$var$_templateObject15;
function $bb6a8a3022cc23ea$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $bb6a8a3022cc23ea$var$color = $bb6a8a3022cc23ea$exports.color = Object.freeze({
    p100: "#EEF7FF",
    p200: "#9AC7EF",
    p300: "#5AB1FF",
    p400: "#1D71F3",
    p500: "#1A4EC0",
    p600: "#112F86",
    a100: "#FFF6EC",
    a200: "#FFD3A5",
    a300: "#FF8932",
    a400: "#FF670A",
    a500: "#FF4D00",
    a600: "#A12A0B",
    b100: "#F0FDF1",
    b200: "#BAF8C3",
    b300: "#84F195",
    b400: "#47E160",
    b500: "#14B22E",
    b600: "#128325",
    c100: "#FDF1F2",
    c200: "#F7CAD4",
    c300: "#EE96A9",
    c400: "#DD5C75",
    c500: "#BB3853",
    c600: "#881D3F",
    d100: "#F6F4FE",
    d200: "#DFD9FB",
    d300: "#AB92F3",
    d400: "#7638DF",
    d500: "#491896",
    d600: "#30165F",
    g100: "#F6F6F8",
    g200: "#ECEEF2",
    g300: "#AEB8CB",
    g400: "#627495",
    g500: "#404B64",
    g600: "#262E41",
    e100: "#FFF1F1",
    e200: "#FFC7C5",
    e300: "#FF6A65",
    e400: "#ED2C25",
    e500: "#C7140E",
    e600: "#6D0400",
    white: "#FFFFFF",
    black: "#000000",
    facebook: "#4464a0",
    twitter: "#1da1f2",
    linkedin: "#0077b5"
});
var $bb6a8a3022cc23ea$var$colorSelector = $bb6a8a3022cc23ea$exports.colorSelector = function colorSelector(colorKey) {
    return function(props) {
        return props.theme.color[colorKey.toLowerCase()];
    };
};
var $bb6a8a3022cc23ea$var$typo = $bb6a8a3022cc23ea$exports.typo = Object.freeze(Object.keys($bebaee556f9a4756$exports.FONTS).reduce(function(acc, key) {
    acc[key] = (0, $h6i5w$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject || ($bb6a8a3022cc23ea$var$_templateObject = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n      font-size: ",
        ";\n      font-family: ",
        ";\n      line-height: ",
        ";\n    "
    ])), $bebaee556f9a4756$exports.FONTS[key].fontSize, $bebaee556f9a4756$exports.FONTS[key].fontFamily, $bebaee556f9a4756$exports.FONTS[key].lineHeight);
    return acc;
}, {}));
var $bb6a8a3022cc23ea$var$typoSelector = $bb6a8a3022cc23ea$exports.typoSelector = function typoSelector(typoKey) {
    return function(props) {
        return props.theme.typo[typoKey];
    };
};
var $bb6a8a3022cc23ea$var$fontWeight = $bb6a8a3022cc23ea$exports.fontWeight = Object.freeze({
    light: (0, $h6i5w$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject2 || ($bb6a8a3022cc23ea$var$_templateObject2 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    font-weight: 300;\n  "
    ]))),
    regular: (0, $h6i5w$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject3 || ($bb6a8a3022cc23ea$var$_templateObject3 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    font-weight: 400;\n  "
    ]))),
    medium: (0, $h6i5w$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject4 || ($bb6a8a3022cc23ea$var$_templateObject4 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    font-weight: 600;\n  "
    ]))),
    bold: (0, $h6i5w$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject5 || ($bb6a8a3022cc23ea$var$_templateObject5 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    font-weight: 700;\n  "
    ])))
});
var $bb6a8a3022cc23ea$var$boxShadowFocus = $bb6a8a3022cc23ea$exports.boxShadowFocus = (0, $h6i5w$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject6 || ($bb6a8a3022cc23ea$var$_templateObject6 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
    "\n  &:focus {\n    box-shadow: 0px 0px 10px ",
    ";\n  }\n"
])), $bb6a8a3022cc23ea$var$color.d100);
var $bb6a8a3022cc23ea$var$gradient = $bb6a8a3022cc23ea$exports.gradient = Object.freeze({
    lagoon: (0, $h6i5w$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject7 || ($bb6a8a3022cc23ea$var$_templateObject7 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    background-image: linear-gradient(\n      87.41deg,\n      ",
        " 4.03%,\n      ",
        " 95.69%\n    );\n  "
    ])), $bb6a8a3022cc23ea$var$color.p500, $bb6a8a3022cc23ea$var$color.p600),
    wave: (0, $h6i5w$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject8 || ($bb6a8a3022cc23ea$var$_templateObject8 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    background-image: linear-gradient(236.19deg, #133599 7.5%, #05164a 86.12%);\n  "
    ]))),
    nector: (0, $h6i5w$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject9 || ($bb6a8a3022cc23ea$var$_templateObject9 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    background-image: linear-gradient(\n      84.4deg,\n      #e00051 6.75%,\n      ",
        " 97.26%\n    );\n  "
    ])), $bb6a8a3022cc23ea$var$color.a500)
});
var $bb6a8a3022cc23ea$var$boxShadow = $bb6a8a3022cc23ea$exports.boxShadow = Object.freeze({
    level1: (0, $h6i5w$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject10 || ($bb6a8a3022cc23ea$var$_templateObject10 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.07);\n  "
    ]))),
    level2: (0, $h6i5w$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject11 || ($bb6a8a3022cc23ea$var$_templateObject11 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.07);\n  "
    ]))),
    level3: (0, $h6i5w$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject12 || ($bb6a8a3022cc23ea$var$_templateObject12 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.07);\n  "
    ]))),
    level4: (0, $h6i5w$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject13 || ($bb6a8a3022cc23ea$var$_templateObject13 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 14px 28px rgba(0, 0, 0, 0.1);\n  "
    ]))),
    level5: (0, $h6i5w$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject14 || ($bb6a8a3022cc23ea$var$_templateObject14 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 19px 38px rgba(0, 0, 0, 0.15);\n  "
    ]))),
    focus: (0, $h6i5w$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject15 || ($bb6a8a3022cc23ea$var$_templateObject15 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 0px 10px ",
        ";\n  "
    ])), $bb6a8a3022cc23ea$var$color.d100)
});
var $bb6a8a3022cc23ea$var$border = $bb6a8a3022cc23ea$exports.border = Object.freeze({
    level1: "0.3px solid rgba(130, 130, 130, 0.5)"
});
var $bb6a8a3022cc23ea$var$layer = $bb6a8a3022cc23ea$exports.layer = Object.freeze({
    hidden: -1,
    select: 5,
    newQuoteButton: 45,
    navbar: 50,
    tooltip: 60,
    mobileSocialFooter: 70,
    popup: 90,
    modal: 100,
    slideOut: 1101,
    welcomeModal: 1301
});
var $bb6a8a3022cc23ea$var$viewports = $bb6a8a3022cc23ea$exports.viewports = {
    mobile: {
        width: 360,
        breakpoint: "sm"
    },
    tablet: {
        width: 768,
        breakpoint: "md"
    },
    desktop: {
        width: 1200,
        breakpoint: "lg"
    }
};
// https://material-ui.com/customization/default-theme/?expend-path=$.breakpoints.values
var $bb6a8a3022cc23ea$var$breakpoint = $bb6a8a3022cc23ea$exports.breakpoint = Object.freeze({
    // this prop is needed because webapp/imports/styledComponents/Grid/Column.js uses xs viewport
    xs: 0,
    sm: 0,
    md: $bb6a8a3022cc23ea$var$viewports.tablet.width,
    lg: $bb6a8a3022cc23ea$var$viewports.desktop.width
});
// https://getbootstrap.com/docs/4.3/layout/overview/
var $bb6a8a3022cc23ea$var$query = $bb6a8a3022cc23ea$exports.query = {
    min: {
        solve: function solve(width) {
            return "(min-width: ".concat(width, "px)");
        },
        tablet: "(min-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.md, "px)")
    },
    max: {
        solve: function solve(width) {
            return "(max-width: ".concat(width - 0.02, "px)");
        },
        tablet: "(max-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.lg - 0.02, "px)")
    },
    mobile: "(max-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.md - 0.02, "px)"),
    tablet: "(min-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.md, "px) and (max-width: ").concat($bb6a8a3022cc23ea$var$breakpoint.lg - 0.02, "px)"),
    desktop: "(min-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.lg, "px)"),
    dpr2x: "(min-resolution: 2dppx), (min-resolution: 192dpi)",
    mobileDpr2x: "(max-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.md - 0.02, "px) and (min-resolution: 2dppx), (max-width: ").concat($bb6a8a3022cc23ea$var$breakpoint.md - 0.02, "px) and (min-resolution: 192dpi)")
};
Object.keys($bb6a8a3022cc23ea$var$breakpoint).forEach(function(key) {
    $bb6a8a3022cc23ea$var$query.min[key] = $bb6a8a3022cc23ea$var$query.min.solve($bb6a8a3022cc23ea$var$breakpoint[key]);
    $bb6a8a3022cc23ea$var$query.max[key] = $bb6a8a3022cc23ea$var$query.max.solve($bb6a8a3022cc23ea$var$breakpoint[key]);
});
Object.freeze($bb6a8a3022cc23ea$var$query);
Object.freeze($bb6a8a3022cc23ea$var$query.min);
Object.freeze($bb6a8a3022cc23ea$var$query.max);
var $bb6a8a3022cc23ea$var$Theme = $bb6a8a3022cc23ea$exports.Theme = Object.freeze({
    color: $bb6a8a3022cc23ea$var$color,
    typo: $bb6a8a3022cc23ea$var$typo,
    border: $bb6a8a3022cc23ea$var$border,
    boxShadow: $bb6a8a3022cc23ea$var$boxShadow,
    boxShadowFocus: $bb6a8a3022cc23ea$var$boxShadowFocus,
    gradient: $bb6a8a3022cc23ea$var$gradient,
    layer: $bb6a8a3022cc23ea$var$layer,
    fontWeight: $bb6a8a3022cc23ea$var$fontWeight,
    query: $bb6a8a3022cc23ea$var$query
});


var $e3408eb85cf737bc$var$defaultRootStyle = $e3408eb85cf737bc$exports.defaultRootStyle = {
    backgroundColor: "transparent"
};
var $e3408eb85cf737bc$var$defaultLabelStyle = $e3408eb85cf737bc$exports.defaultLabelStyle = {
    fontWeight: "medium",
    textTransform: "capitalize",
    fontFamily: "inherit"
};
var $e3408eb85cf737bc$var$defaultTabIndicatorStyle = $e3408eb85cf737bc$exports.defaultTabIndicatorStyle = {
    backgroundColor: (0, $bb6a8a3022cc23ea$exports.colorSelector)("p500")
};
var $e3408eb85cf737bc$var$sizeStyles = $e3408eb85cf737bc$exports.sizeStyles = {
    "default": {
        fontSize: $bebaee556f9a4756$exports.FONTS.bodyL.fontSize,
        lineHeight: $bebaee556f9a4756$exports.FONTS.bodyL.lineHeight
    },
    extraSmall: {
        fontSize: $bebaee556f9a4756$exports.FONTS.bodyS.fontSize,
        lineHeight: $bebaee556f9a4756$exports.FONTS.bodyS.lineHeight
    },
    small: {
        fontSize: $bebaee556f9a4756$exports.FONTS.bodyM.fontSize,
        lineHeight: $bebaee556f9a4756$exports.FONTS.bodyM.lineHeight
    },
    medium: {
        fontSize: $bebaee556f9a4756$exports.FONTS.bodyL.fontSize,
        lineHeight: $bebaee556f9a4756$exports.FONTS.bodyL.lineHeight
    },
    large: {
        fontSize: $bebaee556f9a4756$exports.FONTS.displayM.fontSize,
        lineHeight: $bebaee556f9a4756$exports.FONTS.displayM.lineHeight
    }
};
var $e3408eb85cf737bc$var$labelStyles = $e3408eb85cf737bc$exports.labelStyles = {
    "false": {
        color: (0, $bb6a8a3022cc23ea$exports.colorSelector)("g500"),
        hover: {
            color: (0, $bb6a8a3022cc23ea$exports.colorSelector)("black")
        }
    },
    "true": {
        color: (0, $bb6a8a3022cc23ea$exports.colorSelector)("p500"),
        hover: {
            color: (0, $bb6a8a3022cc23ea$exports.colorSelector)("p500")
        }
    }
};
var $e3408eb85cf737bc$var$tabRootStyles = $e3408eb85cf737bc$exports.tabRootStyles = {
    "default": {
        minHeight: "48px"
    },
    extraSmall: {
        minWidth: "80px",
        minHeight: "48px"
    },
    small: {
        minWidth: "100px",
        minHeight: "48px"
    },
    medium: {
        minHeight: "48px"
    },
    large: {
        minHeight: "48px"
    }
};
var $e3408eb85cf737bc$var$tabLabelContainerStyles = $e3408eb85cf737bc$exports.tabLabelContainerStyles = {
    "default": {},
    extraSmall: {
        padding: "0 8px"
    },
    small: {
        padding: "0 15px"
    },
    medium: {},
    large: {}
};
var $e3408eb85cf737bc$var$rippleStyle = $e3408eb85cf737bc$exports.rippleStyle = {
    color: (0, $bb6a8a3022cc23ea$exports.colorSelector)("p500")
};



var $0c680dbfab605dda$var$_excluded = [
    "classes",
    "label",
    "$pillStyled"
], $0c680dbfab605dda$var$_excluded2 = [
    "classes",
    "$pillStyled"
];
var $0c680dbfab605dda$var$_templateObject, $0c680dbfab605dda$var$_templateObject2, $0c680dbfab605dda$var$_templateObject3, $0c680dbfab605dda$var$_templateObject4, $0c680dbfab605dda$var$_templateObject5, $0c680dbfab605dda$var$_templateObject6;
function $0c680dbfab605dda$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0c680dbfab605dda$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $0c680dbfab605dda$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $0c680dbfab605dda$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $0c680dbfab605dda$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $0c680dbfab605dda$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $0c680dbfab605dda$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0c680dbfab605dda$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0c680dbfab605dda$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0c680dbfab605dda$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0c680dbfab605dda$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0c680dbfab605dda$var$_defineProperty(e, r, t) {
    return (r = $0c680dbfab605dda$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0c680dbfab605dda$var$_toPropertyKey(t) {
    var i = $0c680dbfab605dda$var$_toPrimitive(t, "string");
    return "symbol" == $0c680dbfab605dda$var$_typeof(i) ? i : i + "";
}
function $0c680dbfab605dda$var$_toPrimitive(t, r) {
    if ("object" != $0c680dbfab605dda$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0c680dbfab605dda$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0c680dbfab605dda$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $0c680dbfab605dda$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $0c680dbfab605dda$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $0c680dbfab605dda$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $0c680dbfab605dda$var$StyledTab = $0c680dbfab605dda$exports.StyledTab = (0, $0c680dbfab605dda$var$_styledComponents["default"])(function(_ref) {
    var classes = _ref.classes, label = _ref.label, $pillStyled = _ref.$pillStyled, other = $0c680dbfab605dda$var$_objectWithoutProperties(_ref, $0c680dbfab605dda$var$_excluded);
    return /*#__PURE__*/ (0, $h6i5w$reactjsxruntime.jsx)($0c680dbfab605dda$var$_Tab["default"], $0c680dbfab605dda$var$_objectSpread($0c680dbfab605dda$var$_objectSpread({}, other), {}, {
        label: label,
        TouchRippleProps: {
            style: $e3408eb85cf737bc$exports.rippleStyle
        },
        classes: $0c680dbfab605dda$var$_objectSpread($0c680dbfab605dda$var$_objectSpread({}, classes), {}, {
            root: "root",
            selected: "selected"
        })
    }));
})($0c680dbfab605dda$var$_templateObject || ($0c680dbfab605dda$var$_templateObject = $0c680dbfab605dda$var$_taggedTemplateLiteral([
    "\n  &.root {\n    min-width: ",
    ";\n    padding: ",
    ";\n    font-family: ",
    ";\n    ",
    ";\n    text-transform: ",
    ";\n    font-size: ",
    ";\n    line-height: ",
    ";\n    color: ",
    ";\n    &:hover {\n      color: ",
    ";\n    }\n\n    &:focus {\n      box-shadow: none;\n    }\n    &.Mui-selected {\n      color: ",
    ";\n    }\n  }\n\n  ",
    "\n  ",
    "\n"
])), function(props) {
    return $e3408eb85cf737bc$exports.tabRootStyles[props.size].minWidth;
}, function(props) {
    return $e3408eb85cf737bc$exports.tabLabelContainerStyles[props.size].padding;
}, $e3408eb85cf737bc$exports.defaultLabelStyle.fontFamily, function(props) {
    return props.theme.fontWeight[$e3408eb85cf737bc$exports.defaultLabelStyle.fontWeight];
}, $e3408eb85cf737bc$exports.defaultLabelStyle.textTransform, function(props) {
    return $e3408eb85cf737bc$exports.sizeStyles[props.size].fontSize;
}, function(props) {
    return $e3408eb85cf737bc$exports.sizeStyles[props.size].lineHeight;
}, function(props) {
    return $e3408eb85cf737bc$exports.labelStyles["".concat(props.$isActive)].color;
}, function(props) {
    return $e3408eb85cf737bc$exports.labelStyles["".concat(props.$isActive)].hover.color;
}, function(props) {
    return props.theme.color.p500;
}, function(props) {
    return props.$pillStyled && (0, $0c680dbfab605dda$var$_styledComponents.css)($0c680dbfab605dda$var$_templateObject2 || ($0c680dbfab605dda$var$_templateObject2 = $0c680dbfab605dda$var$_taggedTemplateLiteral([
        "\n      &.root {\n        color: ",
        ";\n        ",
        ";\n        ",
        ";\n        border-radius: 8px;\n\n        &.Mui-selected {\n          background-color: ",
        ";\n        }\n\n        &:hover {\n          color: ",
        ";\n        }\n      }\n    "
    ])), function(props) {
        return props.theme.color.g500;
    }, function(props) {
        return props.theme.typo.bodyL;
    }, function(props) {
        return props.theme.fontWeight.medium;
    }, function(props) {
        return props.theme.color.white;
    }, function(props) {
        return props.theme.color.p500;
    });
}, function(props) {
    return props.$fullWidthTab && (0, $0c680dbfab605dda$var$_styledComponents.css)($0c680dbfab605dda$var$_templateObject3 || ($0c680dbfab605dda$var$_templateObject3 = $0c680dbfab605dda$var$_taggedTemplateLiteral([
        "\n      @media ",
        " {\n        flex: 1;\n      }\n    "
    ])), function(props) {
        return props.theme.query.min.md;
    });
});
var $0c680dbfab605dda$var$StyledTabs = $0c680dbfab605dda$exports.StyledTabs = (0, $0c680dbfab605dda$var$_styledComponents["default"])(function(_ref2) {
    var classes = _ref2.classes, $pillStyled = _ref2.$pillStyled, other = $0c680dbfab605dda$var$_objectWithoutProperties(_ref2, $0c680dbfab605dda$var$_excluded2);
    return /*#__PURE__*/ (0, $h6i5w$reactjsxruntime.jsx)($0c680dbfab605dda$var$_Tabs["default"], $0c680dbfab605dda$var$_objectSpread($0c680dbfab605dda$var$_objectSpread({}, other), {}, {
        classes: $0c680dbfab605dda$var$_objectSpread($0c680dbfab605dda$var$_objectSpread({}, classes), {}, {
            root: "root",
            indicator: "indicator",
            scrollable: "scrollable",
            flexContainer: "flexContainer"
        })
    }));
})($0c680dbfab605dda$var$_templateObject4 || ($0c680dbfab605dda$var$_templateObject4 = $0c680dbfab605dda$var$_taggedTemplateLiteral([
    "\n  ",
    "\n\n  &.root {\n    background-color: ",
    ";\n    min-height: ",
    ";\n  }\n\n  & .indicator {\n    background-color: ",
    ";\n    height: 0;\n    border: 1.5px solid ",
    ";\n    z-index: 1000;\n  }\n\n  & .scrollable {\n    overflow-x: scroll;\n    scrollbar-width: none;\n  }\n\n  & .scrollable::-webkit-scrollbar {\n    display: none;\n  }\n\n  ",
    "\n"
])), function(props) {
    return props.$underline && (0, $0c680dbfab605dda$var$_styledComponents.css)($0c680dbfab605dda$var$_templateObject5 || ($0c680dbfab605dda$var$_templateObject5 = $0c680dbfab605dda$var$_taggedTemplateLiteral([
        "\n      position: relative;\n\n      ::after {\n        content: '';\n        position: absolute;\n        display: block;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        width: 100%;\n        border-bottom: 1px solid ",
        ";\n        z-index: ",
        ";\n      }\n    "
    ])), props.theme.color.g500, props.theme.layer.modal);
}, $e3408eb85cf737bc$exports.defaultRootStyle.backgroundColor, function(props) {
    return $e3408eb85cf737bc$exports.tabRootStyles[props.size].minHeight;
}, $e3408eb85cf737bc$exports.defaultTabIndicatorStyle.backgroundColor, $e3408eb85cf737bc$exports.defaultTabIndicatorStyle.backgroundColor, function(props) {
    return props.$pillStyled && (0, $0c680dbfab605dda$var$_styledComponents.css)($0c680dbfab605dda$var$_templateObject6 || ($0c680dbfab605dda$var$_templateObject6 = $0c680dbfab605dda$var$_taggedTemplateLiteral([
        "\n      &.root {\n        background-color: ",
        ";\n        border-radius: 8px;\n        border: 1px solid ",
        ";\n        padding: 8px;\n      }\n      .indicator {\n        display: none;\n      }\n    "
    ])), props.theme.color.g200, props.theme.color.g300);
});



function $fa133ff3e22f1eb7$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($fa133ff3e22f1eb7$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $fa133ff3e22f1eb7$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $fa133ff3e22f1eb7$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $fa133ff3e22f1eb7$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $fa133ff3e22f1eb7$var$_slicedToArray(r, e) {
    return $fa133ff3e22f1eb7$var$_arrayWithHoles(r) || $fa133ff3e22f1eb7$var$_iterableToArrayLimit(r, e) || $fa133ff3e22f1eb7$var$_unsupportedIterableToArray(r, e) || $fa133ff3e22f1eb7$var$_nonIterableRest();
}
function $fa133ff3e22f1eb7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fa133ff3e22f1eb7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $fa133ff3e22f1eb7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $fa133ff3e22f1eb7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $fa133ff3e22f1eb7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $fa133ff3e22f1eb7$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $fa133ff3e22f1eb7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
var $fa133ff3e22f1eb7$var$onChange = $fa133ff3e22f1eb7$exports.onChange = function onChange(setSelectedTab, onChangeCallback) {
    return function(e, value) {
        e.preventDefault();
        setSelectedTab(value);
        if (onChangeCallback) onChangeCallback(value);
    };
};
var $fa133ff3e22f1eb7$var$Tabs = $fa133ff3e22f1eb7$exports.Tabs = function Tabs(props) {
    var _tabs$;
    var preSelectedTab = props.preSelectedTab, tabs = props.tabs, onChangeCallback = props.onChangeCallback, id = props.id, _props$scrollButtons = props.scrollButtons, scrollButtons = _props$scrollButtons === void 0 ? "auto" : _props$scrollButtons, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, _props$underline = props.underline, underline = _props$underline === void 0 ? true : _props$underline, size = props.size, className = props.className, _props$pillStyled = props.pillStyled, pillStyled = _props$pillStyled === void 0 ? false : _props$pillStyled, _props$fullWidthTab = props.fullWidthTab, fullWidthTab = _props$fullWidthTab === void 0 ? false : _props$fullWidthTab;
    var initialSelectedTab = preSelectedTab || (tabs === null || tabs === void 0 ? void 0 : (_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.value);
    var _useState = (0, $fa133ff3e22f1eb7$var$_react.useState)(initialSelectedTab || 0), _useState2 = $fa133ff3e22f1eb7$var$_slicedToArray(_useState, 2), selectedTab = _useState2[0], setSelectedTab = _useState2[1];
    (0, $fa133ff3e22f1eb7$var$_react.useEffect)(function() {
        if (preSelectedTab) setSelectedTab(preSelectedTab);
    }, [
        preSelectedTab
    ]);
    var renderTabs = function renderTabs() {
        return props.tabs.map(function(tab, index) {
            var _props$classes;
            var value = tab.value || index;
            var key = tab.id || "".concat(props.id, "-tab-").concat(index);
            return /*#__PURE__*/ (0, $h6i5w$reactjsxruntime.jsx)($0c680dbfab605dda$exports.StyledTab, {
                className: (_props$classes = props.classes) === null || _props$classes === void 0 ? void 0 : _props$classes.tab,
                id: key,
                value: value,
                label: tab.label,
                size: props.size,
                "data-testid": value,
                $isActive: "".concat(selectedTab === value),
                icon: tab.icon,
                iconPosition: tab.iconPosition,
                $pillStyled: pillStyled,
                $fullWidthTab: fullWidthTab
            }, key);
        });
    };
    return /*#__PURE__*/ (0, $h6i5w$reactjsxruntime.jsx)($0c680dbfab605dda$exports.StyledTabs, {
        id: id,
        scrollButtons: scrollButtons,
        $underline: underline,
        variant: variant,
        size: size,
        className: className,
        value: selectedTab,
        onChange: $fa133ff3e22f1eb7$var$onChange(setSelectedTab, onChangeCallback),
        $pillStyled: pillStyled,
        children: renderTabs()
    }, id);
};




//# sourceMappingURL=index.js.map
